{
	"name": "@atlaskit/reactions",
	"version": "22.5.0"
}
